module.exports = __webpack_public_path__ + "img/tachibana.684d9ef4.jpg";